import React, {useEffect, useState} from 'react'
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import FileUpload from "../../FileUploads/FileUpload";
import DashboardMenu from "../../layout/dashboardMenu";
const EditTask = ({
                      documentUrlDataPublic,
                      documentUploadUrlPublic,
                      updateTask,
                      getTaskById,
                      taskDetailsById = [],
                      UpdateTaskDetails = [],
                      match
                  }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        remarks: '',
        closure_image: '',
        status: '',
        closure_date: ''
    }])
    const [successMessage, setSuccessMessage] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getTaskById(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (UpdateTaskDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(UpdateTaskDetails?.message)
        } else if (UpdateTaskDetails?.status !== undefined && UpdateTaskDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(UpdateTaskDetails?.message)
        }
    }, [UpdateTaskDetails])

    const handleInput = (key, val) => {
        let list = [...inputList]
        inputList[0][key] = val
        setInputList(list)
    }


    useEffect(() => {
        if (taskDetailsById?.status === 2 || taskDetailsById?.status === 3) {

        }
    }, [taskDetailsById])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = [...inputList]
        list[0]['id'] = match?.params?.id
        setIsLoading(true)
        await updateTask(list[0])
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={"task-list/2"}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
            />

            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Task"}
                            url={`task-list/2`}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="card-body">
                                                <div className="user mt-4">
                                                    <div className="form-group row">
                                                        {taskDetailsById?.name !== undefined && taskDetailsById?.name !== '' && taskDetailsById?.name !== null &&
                                                            <div className="col-sm-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Task Type <i
                                                                    className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                        }
                                                        {taskDetailsById?.title !== undefined && taskDetailsById?.title !== '' && taskDetailsById?.title !== null &&
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    // handleInput('description', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                value={taskDetailsById?.title}
                                                                disabled
                                                            />
                                                            </div>
                                                        }
                                                        {taskDetailsById?.description !== undefined && taskDetailsById?.description !== '' && taskDetailsById?.description !== null &&
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    // handleInput('description', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                value={taskDetailsById?.description}
                                                                disabled
                                                            />
                                                            </div>
                                                        }
                                                        {taskDetailsById?.task_date !== undefined && taskDetailsById?.task_date !== '' && taskDetailsById?.task_date !== null &&
                                                            <div className="col-sm-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.task_date}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Task Date
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.client_name !== undefined && taskDetailsById?.client_name !== '' && taskDetailsById?.client_name !== null &&
                                                            <div className="col-sm-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.client_name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Account Name
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.opportunity_name !== undefined && taskDetailsById?.opportunity_name !== '' && taskDetailsById?.opportunity_name !== null &&
                                                            <div className="col-sm-6 float-field">
                                                                <input type="text"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           // handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       value={taskDetailsById?.opportunity_name}
                                                                       id="validationCustom01"
                                                                       disabled
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Opportunity Type
                                                                </label>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.task_image !== undefined && taskDetailsById?.task_image !== '' && taskDetailsById?.task_image !== null &&
                                                            <div className="col-sm-6 mtk-075 float-field" style={{marginBottom:'20px'}}>
                                                                <img src={taskDetailsById?.task_image} alt={""}/>
                                                            </div>
                                                        }

                                                        {taskDetailsById?.status === 'Open' &&
                                                            <>
                                                                <div className="col-sm-6 mt-1 float-field"
                                                                     style={{marginTop: "16px !important"}}>
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleInput('status', e.target.value)
                                                                        }} required>
                                                                        <option value="">Select Status</option>
                                                                        <option value="2">Complete</option>
                                                                        <option value="3">Reject</option>
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Status <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Remarks"
                                                                onChange={(e) => {
                                                                    handleInput('remarks', e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required
                                                            />
                                                                </div>
                                                                <div className="col-sm-6 float-field">
                                                                    <input type="date"
                                                                           className="form-control form-control-user cus-red"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput('closure_date', e.target.value, e)
                                                                           }}
                                                                           id="validationCustom01"
                                                                           required={true}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Closure Date <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-1 float-field mb-3">
                                                                    <FileUpload
                                                                        id={"addAttachment"}
                                                                        accept=".png,.jpg,.jpeg"
                                                                        documentUploadUrl={documentUploadUrlPublic}
                                                                        documentUrlData={documentUrlDataPublic}
                                                                        onChange={(val) => {
                                                                            handleInput('closure_image', val)
                                                                        }}
                                                                        prefilledFilename={""}
                                                                    >
                                                                        File Attachment
                                                                    </FileUpload>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default EditTask